import { useEffect, useRef, useState, useContext, useCallback } from 'react';
import './pane-left-recipients-item-template.scss'
import moment from 'moment';
import { RecipientContext } from '../context/recipient-context';
import { ReadContext } from '../context/read-context';

export default function RecipientsItem({ recipient, handleRead }) {

  const [recipientSelected, setRecipientSelected] = useContext(RecipientContext);
  const [read, setRead] = useContext(ReadContext);
  const [newMessages, setNewMessages] = useState([]);

  useEffect(() => {

    if (!recipient)
      return;

    if (recipient.newMessages && recipient.newMessages.length) {
      setNewMessages([...recipient.newMessages]);
    } else {
      setNewMessages([]);
    }
  }, [recipient]);



  const lastOnDate = (message) => {
    let result = '';

    if (message) {
      if (moment(message.ondate).isSame(moment(), 'day')) {
        result = "cьогодні: " + moment(message.ondate).format("LT");
      }
      else if (moment(message.ondate).isSame(moment().subtract(1, 'day'), 'day')) {
        result = "вчора: " + moment(message.ondate).format("LT");
      }
      else {
        result = moment(message.ondate).format("DD.MM HH:mm");
      }
    }

    return result;
  }

  const lastStatus = (status) => {

    let result = "red";

    if (status == 2) {
      result = "orange";
    }
    else if (status == 1) {
      result = "green";
    }

    return result;
  }

  useEffect(() => {

    if (!read || !read.length)
      return;

    handleRead(recipient.id, read);

  }, [read]);

  return (

    <div className={recipientSelected && recipientSelected.id == recipient.id ? "recipient-item-container-selected" : "recipient-item-container"} onClick={() => setRecipientSelected(recipient)}>
      <div>
        <div className='recipient-item-name-short' style={{ borderColor: lastStatus(recipient.status) }}>{recipient.nameShort} </div>
        <div className='recipient-item-name'>{recipient.name}</div>
        <div className='recipient-item-last-message-date'>{lastOnDate(recipient.lastMessage)}</div>
      </div>

      <div>
        <div className='recipient-item-last-message' dangerouslySetInnerHTML={{ __html: recipient.lastMessage ? recipient.lastMessage.text : "" }}></div>
        <div className='recipient-item-new-messages' style={{ display: newMessages.length ? "flex" : "none" }}>{newMessages.length}</div>
      </div>
    </div>

  )
}


